import moment from 'moment'
import { lastGradeEnum } from '../Modal/newPlanModal/Sections/Student/grades'

const SCHOOL_YEAR_START_MONTH = 7; // agosto (0-based)
const getAcademicYear = () => {
let y = moment().year()
if (moment().month() >= SCHOOL_YEAR_START_MONTH) y += 1
return y
}
export const getValues = (date, type) => {
  const month = moment(date).month()
  let year = moment(date).year()
  const academicYear = getAcademicYear()
  // Ajustar el año académico
  if (month >= SCHOOL_YEAR_START_MONTH) { 
    year += 1;
  }
  const difY = year - academicYear 

    switch (type) {
      case 'class':
        return year.toString().substring(2, 4)// Obtener el último par de dígitos del año
      default:
          // Ajuste para que el ciclo académico y el grado se calculen correctamente
          const grade = lastGradeEnum - difY
        return grade > 12 ? '12+' : grade;
  }
}


export default {
    getValues
}